/**
 * Add basic user agent strings to the document body.
 * This is meant for minor CSS adjustments and should not be used
 * in place of feature detection.
 */
const deviceDetect = () => {

  const ua = window.navigator.userAgent

  const conditions: Record<string, boolean> = {}

  conditions.ios = !! ua.match( /iPad/i ) || !! ua.match( /iPhone/i )
  conditions.webkit = !! ua.match( /WebKit/i )
  conditions.iosSafari = conditions.ios && conditions.webkit && ! ua.match( /CriOS/i ) && ! ua.match( /OPiOS/i )

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: TS2339: Property does not exist on type
  conditions.chrome = window.chrome
  conditions.safari = ua.indexOf( 'Safari' ) > -1 && ! conditions.chrome
  conditions.ie = ua.indexOf( 'MSIE' ) > -1
  conditions.firefox = ua.indexOf( 'Firefox' ) > -1
  conditions.edge = ua.indexOf( 'Edge' ) > -1
  conditions.appleDevice = [ 'iPad', 'iPhone', 'iPod' ].indexOf( navigator.platform ) >= 0
  conditions.nativeAndroid = ( ( ua.indexOf( 'Mozilla/5.0' ) > -1 && ua.indexOf( 'Android ' ) > -1 && ua.indexOf( 'AppleWebKit' ) > -1 ) && ( ua.indexOf( 'Version' ) > -1 ) )

  Object.entries( conditions ).forEach( ( [ condition, truth ] ) => truth ? document.body.classList.add( condition ) : '' )

}

export default deviceDetect
